// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1a6eb687","831":"f19b8e52"}[chunkId] + ".chunk.js";
};